import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsLC: CultureInfo = {
  name: 'es-LC',
  displayName: 'español (Santa Lucía)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-LC',
  parent: CultureInfoEs
};
